export default __webpack_public_path__ + "static/media/tickIcon.27a75aae.svg";